import React from 'react';
import CreateWeekChallenge from './CreateWeekChallenge';
import Challenges from './Challenges';
import RankingByRegion from './RankingByRegion';
import RankingByParticipant from './RankingByParticipant';
import ChallengeResult from './ChallengeResult';
import ChallengeTab from './ChallengeTab';
import { ViewChallenge } from './ChallengeResult/ViewChallenge';
import ViewParticipantResult from './ChallengeResult/ViewParticipantResult';
import { DashboardContent } from '@/layouts/dashboard';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { TiaBanner } from '@/components/custom/tia-banner';
import { DESAFIO_SEMANA } from '@/pages/dashboard/home-teacher/teacher-character';
import PlayfulChallengeTab from './Playful/ChallengeTab';

export function WeekChallenge(props) {
  const { selectedTab, uri } = props;
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  const playfulSectionName = {
    desafios: 'Desafios',
    'ranking-por-regiao': 'Ranking por região',
    'ranking-por-participante': 'Ranking por participante',
    resultados: 'Resultados'
  }[selectedTab];

  const breadcrumbs = isPlayfulTeacherTheme
    ? {
        title: 'Aprendizado Dinâmico - Desafio da Semana',
        nav: [
          {
            route: uri,
            name: playfulSectionName ?? 'Desafios',
            isActive: true
          }
        ]
      }
    : {
        title: 'Aprendizado Dinâmico',
        nav: [
          {
            route: uri,
            name: 'Desafio da Semana',
            isActive: true
          }
        ]
      };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      {isPlayfulTeacherTheme && (
        <TiaBanner
          className="mb-6 sm:mt-16"
          image={DESAFIO_SEMANA}
          imageAlt="Personagem do professor"
          imageHeight={190}
          imageOffset={270}
          bubbleCorner="tl"
          bubbleMaxWidth={600}
          text="Aqui estão seus desafios da semana! Acompanhe as participações, publique novos desafios e mantenha seus alunos aprendendo de um jeito divertido. 🎯"
        />
      )}

      {isPlayfulTeacherTheme ? <PlayfulChallengeTab selectedTab={selectedTab} /> : <ChallengeTab selectedTab={selectedTab} />}

      {selectedTab === 'desafios' && <Challenges playful={isPlayfulTeacherTheme} />}
      {selectedTab === 'ranking-por-regiao' && <RankingByRegion playful={isPlayfulTeacherTheme} />}
      {selectedTab === 'ranking-por-participante' && <RankingByParticipant playful={isPlayfulTeacherTheme} />}
      {selectedTab === 'resultados' && <ChallengeResult playful={isPlayfulTeacherTheme} />}
    </DashboardContent>
  );
}

export { WeekChallenge as default, CreateWeekChallenge, ViewChallenge, ViewParticipantResult };
